/*
 * @Author: 任晓帅
 * @Contact: VX:ren18321147631
 * @Date: 2026-02-14 15:41:28
 * @Description: 不可进行二次销售
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { requiresAuth: false }
  },
  {
    path:'/loginaccount',
    name:'LoginAccount',
    component: () => import('@/views/Loginaccount.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/components/Layout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue')
      },
      {
        path: 'works',
        name: 'WorksList',
        component: () => import('@/views/Works/WorksList.vue')
      },
      {
        path: 'works/create',
        name: 'WorkCreate',
        component: () => import('@/views/Works/WorkCreate.vue')
      },
      
      {
        path: 'analytics',
        name: 'Analytics',
        component: () => import('@/views/Analytics.vue')
      },
      {
        path: 'earnings',
        name: 'Earnings',
        component: () => import('@/views/Earnings.vue')
      },
      {
        path: 'settings/profile',
        name: 'Profile',
        component: () => import('@/views/Settings/Profile.vue')
      },
      {
        path: 'settings/account',
        name: 'Account',
        component: () => import('@/views/Settings/Account.vue')
      },
      {
        path: 'works/video-upload',
        name: 'VideoUpload',
        component: () => import('@/views/Works/VideoUpload.vue'),
        meta: { title: '上传视频' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 1. 获取登录 token（从 cookie/localStorage）
  const token = getToken()
  console.log('路由守卫检查登录状态，token:', token)
  // 2. 如果已登录
  if (token) {
    // 如果访问登录页，直接跳转到首页
    if (to.path === '/login') {
      next('/')
    } else {
      next() // 放行
    }
  } 
  // 3. 未登录
  else {
    // 检查目标路由是否需要登录
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // 需要登录但未登录，跳转到登录页，并带上 redirect 参数
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 登录后自动跳回原页面
      })
    } else {
      next() // 白名单路由，直接放行
    }
  }
})

export default router